module.exports = __webpack_public_path__ + "static/media/success.dd558f05.png";